export enum FlutterAction {
    OTP_VERIFIED = 'wallet_pin_otp_verified',
    OTP_BLOCKED = 'wallet_pin_otp_blocked',
    OTP_REQUEST_FAILED = 'wallet_pin_otp_request_failed',
    ERROR = 'wallet_pin_otp_error',
    BINDING_SUCCESS = 'wallet_binding_success',
    BINDING_FAILED = 'wallet_binding_failed',
    TRX_SUCCESS = 'wallet_trx_success'
}